import { STOPWORDS, TJC } from "./globals";

export function removerStopwords(texto:string) {
  STOPWORDS.forEach((sw) => {
    let ptrn = new RegExp(` ${sw} `, 'gi');
    texto = texto.replaceAll(ptrn, ' ');
  });
  return texto;
}

let protecaoTJC:{[x:string] : string} = {};

export function protegerTermos(text:string) {
  let count = 0;
  TJC.forEach((p) => {
    let match = text.match(p)
    if (match) {
      let v = `tejur${count}`;
      protecaoTJC[v] = match[0];
      text = text.replace(p, v);
      count++;
    }
  });
  return text;
}

export function desprotegerTJC(text:string) {
  Object.keys(protecaoTJC).forEach((v) => {
    text = text.replace(v, `"${protecaoTJC[v]}"`);
  });
  protecaoTJC = {};
  return text;
}
